import { render, staticRenderFns } from "./OrderIncidentBadge.vue?vue&type=template&id=5122d0c1&"
import script from "./OrderIncidentBadge.vue?vue&type=script&lang=js&"
export * from "./OrderIncidentBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports